export default "__VITE_ASSET__a9304424__"